export default __webpack_public_path__ + "static/media/menu.0fda9430.svg";